import CreateListResourceInteractor from "../../core/interactor/app/crud/CreateListResourceInteractor";
import { IIndexTypeCategory } from "../model/IndexTypeCategory";

export default class ConnectIndexTypeCategoriesInteractor {
  private createListResource: CreateListResourceInteractor<IIndexTypeCategory>;

  constructor({ createListResource }: any) {
    this.createListResource = createListResource;
  }

  async execute(indexTypeCategoryId: number, categories: IIndexTypeCategory[]) {
    return this.createListResource.execute(
      `/index-type-categories/${indexTypeCategoryId}/candidates`,
      categories
    );
  }
}
